import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideCacheableAnimationLoader, provideLottieOptions } from 'ngx-lottie';
import { provideTranslateLoader, provideTranslateService } from '@ngx-translate/core';
import { provideHttpClient } from '@angular/common/http';
import { routes } from './app.routes';
import { LottiePreloaderService } from './services/lottie-preloader.service';
import { FallbackTranslateLoader } from './services/fallback-translate-loader';
import { DEFAULT_LANG, LanguageStorageService } from './services/language-storage.service';
import { SizeService } from './services/size-service';
import lottie from 'lottie-web';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    provideLottieOptions({
      player: () => lottie,
    }),
    provideCacheableAnimationLoader(),
    provideAppInitializer(() => {
      inject(LottiePreloaderService);
      inject(SizeService);
      return inject(LanguageStorageService).init();
    }),
    provideTranslateService({
      loader: provideTranslateLoader(FallbackTranslateLoader),
      fallbackLang: DEFAULT_LANG,
    }),
  ],
};
